var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2501_6655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6662 78.3125H11.6662C9.89807 78.3125 8.20238 77.6101 6.95213 76.3599C5.70189 75.1096 4.99951 73.4139 4.99951 71.6458V8.3125",
    stroke: "#E59E6D",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3328 1.65625H11.6662C9.89807 1.65625 8.20238 2.35863 6.95213 3.60887C5.70189 4.85911 4.99951 6.55481 4.99951 8.32292C4.99951 10.091 5.70189 11.7867 6.95213 13.037C8.20238 14.2872 9.89807 14.9896 11.6662 14.9896H64.9995C65.8836 14.9896 66.7314 15.3408 67.3565 15.9659C67.9817 16.591 68.3328 17.4389 68.3328 18.3229V29.9896",
    stroke: "#E59E6D",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6792 8.3125H65.0125",
    stroke: "#E59E6D",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9995 58.3125C34.9995 63.6168 37.1066 68.7039 40.8574 72.4546C44.6081 76.2054 49.6952 78.3125 54.9995 78.3125C60.3038 78.3125 65.3909 76.2054 69.1416 72.4546C72.8924 68.7039 74.9995 63.6168 74.9995 58.3125C74.9995 53.0082 72.8924 47.9211 69.1416 44.1704C65.3909 40.4196 60.3038 38.3125 54.9995 38.3125C49.6952 38.3125 44.6081 40.4196 40.8574 44.1704C37.1066 47.9211 34.9995 53.0082 34.9995 58.3125Z",
    stroke: "#E59E6D",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.999 48.3438V68.3437",
    stroke: "#E59E6D",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.999 68.3125L47.499 60.8125",
    stroke: "#E59E6D",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.999 68.3125L62.499 60.8125",
    stroke: "#E59E6D",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2501_6655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookDownload);
export default __webpack_public_path__ + "static/media/book-download.ec96483c0a12948e4d5d25e98d84436a.svg";
export { ForwardRef as ReactComponent };